import React from 'react';
import { Trans, useTranslation } from 'react-i18next'; // 1. Imports
import './ToursPage.css';
import ContactButton from '../../../atoms/ContactButton/ContactButton';

import toursHero from '../../../../assets/tours-hero.png'; 
import tiburonBallenaImg from '../../../../assets/tour-tiburon-ballena.png'; 
import tresIslasImg from '../../../../assets/tour-tres-islas.png'; 
import chichenItzaImg from '../../../../assets/tour-chichen-itza.png'; 
import pescaAlturaImg from '../../../../assets/tour-pesca-altura.png'; 
import miniPescaImg from '../../../../assets/tour-mini-pesca.png'; 
import kayaksImg from '../../../../assets/tour-kayaks.png'; 
import carritoGolfImg from '../../../../assets/tour-carrito-golf.png'; 
import bioluminiscenciaImg from '../../../../assets/tour-bioluminiscencia.png'; 
import tourSobreElAireImg from '../../../../assets/tour-sobre-el-aire.png'; 

const ToursPage: React.FC = () => {
  // 2. Hook
  const { t } = useTranslation();

  // Para el Tiburón Ballena, necesitamos la lista como array
  const whaleSharkIncludes = t('toursPage:tours.whaleShark.details.includesList', { returnObjects: true }) as string[];
  const safeWhaleSharkIncludes = Array.isArray(whaleSharkIncludes) ? whaleSharkIncludes : [];

  return (
    <div className="tours-page-container">
      
      {/* --- 1. Hero Section --- */}
      <header 
        className="tours-hero"
        style={{ backgroundImage: `url(${toursHero})` }}
      >
        <div className="hero-overlay"></div>
        <h1 className="hero-title">
          <Trans i18nKey="toursPage:heroTitle" />
        </h1>
      </header>

      {/* --- 2. Intro Section (Negra) --- */}
      <section className="tours-intro-black">
        <h2 className="intro-title">
          <Trans i18nKey="toursPage:intro.title" />
        </h2>
        <p className="intro-description">
          <Trans i18nKey="toursPage:intro.description1" />
        </p>
        <p className="intro-description">
          <Trans 
            i18nKey="toursPage:intro.description2" 
            components={{ strong: <strong /> }}
          />
        </p>
      </section>

      {/* --- 3. Lista de Tours --- */}
      <section className="tours-list-section">
        
        {/* Tour 1: Tiburón Ballena */}
        <article className="tour-item">
          <div className="tour-image-container">
            <img src={tiburonBallenaImg} alt="Tiburón Ballena" className="tour-image" loading="lazy" />
            <ContactButton /> 
          </div>
          <div className="tour-content">
            <h3 className="tour-title">
              <Trans i18nKey="toursPage:tours.whaleShark.title" />
            </h3>
            <p className="tour-description">
              <Trans 
                i18nKey="toursPage:tours.whaleShark.description"
                components={{ strong: <strong /> }}
              />
            </p>
            <div className="tour-details">
              <p><Trans i18nKey="toursPage:tours.whaleShark.details.season" components={{ strong: <strong /> }} /></p>
              <p><Trans i18nKey="toursPage:tours.whaleShark.details.includesLabel" components={{ strong: <strong /> }} /></p>
              <ul>
                {safeWhaleSharkIncludes.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
              <p><Trans i18nKey="toursPage:tours.whaleShark.details.recommendations" components={{ strong: <strong /> }} /></p>
              <p>
                <Trans 
                  i18nKey="toursPage:tours.whaleShark.details.important"
                  components={{ strong: <strong /> }}
                />
              </p>
              <p><Trans i18nKey="toursPage:tours.whaleShark.details.priceNote" /></p>
              <p><Trans i18nKey="toursPage:tours.whaleShark.details.moreInfo" /></p>
            </div>
          </div>
        </article>
        <div className="linea-global"></div>

        {/* Tour 2: Tres Islas */}
        <article className="tour-item tour-item-reverse">
          <div className="tour-image-container">
            <img src={tresIslasImg} alt="Tour clásico tres islas" className="tour-image" loading="lazy" />
            <ContactButton />
          </div>
          <div className="tour-content">
            <h3 className="tour-title">
               <Trans i18nKey="toursPage:tours.threeIslands.title" />
            </h3>
            <p className="tour-description">
              <Trans 
                i18nKey="toursPage:tours.threeIslands.description"
                components={{ strong: <strong /> }}
              />
            </p>
            <div className="tour-details">
              <p><Trans i18nKey="toursPage:tours.threeIslands.details.duration" components={{ strong: <strong /> }} /></p>
              <p><Trans i18nKey="toursPage:tours.threeIslands.details.ideal" components={{ strong: <strong /> }} /></p>
              <p><Trans i18nKey="toursPage:tours.threeIslands.details.includes" components={{ strong: <strong /> }} /></p>
              <p><Trans i18nKey="toursPage:tours.threeIslands.details.suggestions" components={{ strong: <strong /> }} /></p>
            </div>
          </div>
        </article>
       <div className="linea-global"></div>

        {/* Tour 3: Chichén Itzá */}
        <article className="tour-item">
          <div className="tour-image-container">
            <img src={chichenItzaImg} alt="Chichén Itzá" className="tour-image" loading="lazy" />
            <ContactButton /> 
          </div>
          <div className="tour-content">
            <h3 className="tour-title">
              <Trans i18nKey="toursPage:tours.chichenItza.title" />
            </h3>
            <p className="tour-description">
              <Trans 
                i18nKey="toursPage:tours.chichenItza.description"
                components={{ strong: <strong /> }}
              />
            </p>
            <div className="tour-details">
              <p><Trans i18nKey="toursPage:tours.chichenItza.details.includes" components={{ strong: <strong /> }} /></p>
              <p><Trans i18nKey="toursPage:tours.chichenItza.details.duration" components={{ strong: <strong /> }} /></p>
            </div>
          </div>
        </article>
        <div className="linea-global"></div>

        {/* Tour 4: Pesca de altura */}
        <article className="tour-item tour-item-reverse">
          <div className="tour-image-container">
            <img src={pescaAlturaImg} alt="Pesca de altura" className="tour-image" loading="lazy" />
            <ContactButton />
          </div>
          <div className="tour-content">
            <h3 className="tour-title">
              <Trans i18nKey="toursPage:tours.deepSeaFishing.title" />
            </h3>
            <p className="tour-description">
               <Trans 
                i18nKey="toursPage:tours.deepSeaFishing.description"
                components={{ strong: <strong /> }}
              />
            </p>
            <div className="tour-details">
              <p><Trans i18nKey="toursPage:tours.deepSeaFishing.details.shared" /></p>
              <p><Trans i18nKey="toursPage:tours.deepSeaFishing.details.includes" components={{ strong: <strong /> }} /></p>
              <p><Trans i18nKey="toursPage:tours.deepSeaFishing.details.groupSize" /></p>
              <p><Trans i18nKey="toursPage:tours.deepSeaFishing.details.disclaimer" /></p>
            </div>
          </div>
        </article>
        <div className="linea-global"></div>
        
        {/* Tour 5: Mini Pesca */}
        <article className="tour-item">
          <div className="tour-image-container">
            <img src={miniPescaImg} alt="Mini Pesca" className="tour-image" loading="lazy" />
            <ContactButton /> 
          </div>
          <div className="tour-content">
            <h3 className="tour-title">
              <Trans i18nKey="toursPage:tours.miniFishing.title" />
            </h3>
            <p className="tour-description">
              <Trans 
                i18nKey="toursPage:tours.miniFishing.description"
                components={{ strong: <strong /> }}
              />
            </p>
          </div>
        </article>
        <div className="linea-global"></div>

        {/* Tour 6: Tour de Kayaks */}
        <article className="tour-item tour-item-reverse">
          <div className="tour-image-container">
            <img src={kayaksImg} alt="Tour de Kayaks" className="tour-image" loading="lazy" />
            <ContactButton /> 
          </div>
          <div className="tour-content">
            <h3 className="tour-title">
              <Trans i18nKey="toursPage:tours.kayaks.title" />
            </h3>
            <p className="tour-description">
               <Trans 
                i18nKey="toursPage:tours.kayaks.description"
                components={{ strong: <strong /> }}
              />
            </p>
          </div>
        </article>
        <div className="linea-global"></div>

        {/* Tour 7: Carrito de Golf */}
        <article className="tour-item">
          <div className="tour-image-container">
            <img src={carritoGolfImg} alt="Carrito de Golf" className="tour-image" loading="lazy" />
            <ContactButton /> 
          </div>
          <div className="tour-content">
            <h3 className="tour-title">
              <Trans i18nKey="toursPage:tours.golfCart.title" />
            </h3>
            <p className="tour-description">
              <Trans 
                i18nKey="toursPage:tours.golfCart.description"
                components={{ strong: <strong /> }}
              />
            </p>
          </div>
        </article>
        <div className="linea-global"></div>

        {/* Tour 8: Bioluminiscencia */}
        <article className="tour-item tour-item-reverse">
          <div className="tour-image-container">
            <img src={bioluminiscenciaImg} alt="Bioluminiscencia" className="tour-image" loading="lazy" />
            <ContactButton /> 
          </div>
          <div className="tour-content">
            <h3 className="tour-title">
              <Trans i18nKey="toursPage:tours.bioluminescence.title" />
            </h3>
            <p className="tour-description">
              <Trans i18nKey="toursPage:tours.bioluminescence.description" />
            </p>
            <div className="tour-details">
              <p><Trans i18nKey="toursPage:tours.bioluminescence.details.intro" /></p>
              <ul>
                <li>
                  <Trans 
                    i18nKey="toursPage:tours.bioluminescence.details.kayakOption" 
                    components={{ strong: <strong /> }}
                  />
                </li>
                <li>
                  <Trans 
                    i18nKey="toursPage:tours.bioluminescence.details.taxiOption" 
                    components={{ strong: <strong /> }}
                  />
                </li>
              </ul>
              <p><Trans i18nKey="toursPage:tours.bioluminescence.details.outro" /></p>
            </div>
          </div>
        </article>
        <div className="linea-global"></div>

        {/* Tour 9: Tour sobre el aire */}
        <article className="tour-item">
          <div className="tour-image-container">
            <img src={tourSobreElAireImg} alt="Tour sobre el aire" className="tour-image" loading="lazy" />
            <ContactButton /> 
          </div>
          <div className="tour-content">
            <h3 className="tour-title">
              <Trans i18nKey="toursPage:tours.airTour.title" />
            </h3>
            <p className="tour-description">
              <Trans 
                i18nKey="toursPage:tours.airTour.description" 
                components={{ strong: <strong /> }}
              />
            </p>
          </div>
        </article>
        
      </section>
    </div>
  );
};

export default ToursPage;